/**
 * Carregando: esqueleto com a FORMA do conteúdo, não giro no meio da tela.
 *
 * O giro não diz o que vem, e a página salta quando o conteúdo chega. As
 * medidas aqui são as do que vai ocupar o lugar — título, descrição, uma
 * pergunta e três opções —, então a troca não move nada.
 */

export function Esqueleto() {
  return (
    <div className="esqueleto-convite" aria-busy="true" aria-live="polite">
      <span className="so-leitor">Carregando o convite.</span>

      <div className="esqueleto-convite__cabecalho" aria-hidden="true">
        <div className="esqueleto esqueleto-convite__titulo" />
        <div className="esqueleto esqueleto--linha" />
        <div className="esqueleto esqueleto--linha esqueleto-convite__meia" />
      </div>

      <div className="esqueleto-convite__corpo" aria-hidden="true">
        <div className="esqueleto esqueleto-convite__pergunta" />
        <div className="esqueleto esqueleto-convite__opcao" />
        <div className="esqueleto esqueleto-convite__opcao" />
        <div className="esqueleto esqueleto-convite__opcao" />
      </div>
    </div>
  );
}
